interface SectionContainer {
  children: any;
  maxSize?: string;
  removeYPadding?: boolean;
  className?: string;
}

const SectionContainer = ({
  children,
  maxSize,
  removeYPadding = false,
  className,
}: SectionContainer) => {
  const getMaxSize = () => {
    switch (maxSize) {
      case "md":
        return "2xl:max-w-[1000px]";
      case "lg":
        return "2xl:max-w-[1200px]";
      default:
        return "2xl:container";
    }
  };

  return (
    <section
      className={`${
        !removeYPadding ? "py-20" : null
      } px-4 sm:px-8 2xl:px-0 ${getMaxSize()} mx-auto ${className}`}
    >
      {children}
    </section>
  );
};

export default SectionContainer;
